/* eslint-disable */
import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import PropTypes from 'prop-types';
import client from '../../Services/client'
import AuthService from '../../Services/AuthService';
import { withStyles } from '@material-ui/core/styles';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import SuccessMessage from '../AlertMessages/SuccessMsg';
import { SimpleShareButtons } from "react-simple-share";
import CssBaseline from '@material-ui/core/CssBaseline';
import styles from './Styles';
import ReactMarkdown from 'react-markdown'
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';


const BasicExample = () => <SimpleShareButtons />;
const OptionsExample = () => (
    <SimpleShareButtons
      url="https://github.com/swozniak/react-simple-share"
      color="#03A9F4"
      size="50px"
    />
	
  );


class SingleNews extends Component {

	constructor(){
		super()
		this.state = {news: null}
	}

	componentDidMount() {
   	 client.getEntries({content_type: 'connect', 'fields.slug': this.props.match.params.slug})
      .then(response => {
        return response.items[0].fields;
      })
      .then(fields => {
        this.setState({
          news: fields
        });
      })
      .catch(console.error);
  }

	render(props){
		const { auth } = this.state;
		const {classes} = this.props;

		let title;
		let description;
		let slug;
		let imageurl;
		if (this.state.news) {
      	title = this.state.news.title;
      	slug = this.state.news.slug;
				description = this.state.news.description;
				imageurl = this.state.news.newsimage.fields.file.url; 
		}	
		 return(
			<div className={classes.layout}>
			 <Grid container>
              <Grid item md={8}>
				<div className={classes.imageLayout}>
					<img className={classes.img} alt="complex" src= {imageurl} />
				</div>
				<div className={classes.socialShare}>
					<h5>Share with</h5>
					<SimpleShareButtons
						url = {"https://poncianovieira.com/articledetails/"+ slug }
						size="50px"
					/>
				</div>
			  </Grid>
			  <Grid item md={12}>
			  <div className={classes.eventBody}>
			  		<h2>{title}</h2>
					<ReactMarkdown source={description} />
				</div>
			  </Grid>
			</Grid>
			</div>
		);
	}
}

SingleNews.propTypes = {
	classes: PropTypes.object.isRequired,
  };
  
export default withStyles(styles)(SingleNews);






// WEBPACK FOOTER //
// ./src/components/News/SingleNews.js